import { Component, OnInit } from '@angular/core';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { GridOptions, GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AssignDialogComponent } from 'src/app/common/assign-dialog/assign-dialog.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { RequestTypeModalComponent } from './request-type-modal/request-type-modal.component';
import { GM_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { WithdrawComponent } from 'src/app/common/withdraw/withdraw.component';
import { RouteComponent } from 'src/app/common/route/route.component';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';

@Component({
  selector: 'app-grants-applications',
  templateUrl: './grants-applications.component.html',
  styleUrls: ['./grants-applications.component.scss']
})
export class GrantsApplicationsComponent implements OnInit {
  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  alloperations;
  rowData;
  advanceSearch;
  selectedRow;
  caseDetails
  grantsapp: GM_APP;
  grants: GM_APP[];
  menudata: ModuleMenu;
  grantsForm: UntypedFormGroup;
  therapeuticAreas: any;
  GrantTypeList: Array<any> = [];
  IsOnlyGrandType: boolean = false; 
  subGetData: SubscriptionLike;
  TheraputicAreaList: any;
  StatusList: any;

  constructor(
    private router: Router,
    public routerr: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private header: HeadService,
    public apiService: ApidataRequestService,
    private grantsDataShare:GrantsDatashareService
  ) {

  }

  ngOnInit() {
    this.StatusList= [{ "value": "", "label": "All" },{ "value": "1", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Rejected" }, { "value": "7", "label": "On-hold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discarded" }];

    this.collapesedOrNot = false;
    this.setDefaultData();

    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("A")
    });
    var formData = this.grantsForm.value;
    this.setSearchSummary(formData);
    this.GetMasterData();
  }

  setSearchSummary(formData) {
    this.summaryService.getGrantAppAdvSearch("api/gmapp/getadvsearch", formData).subscribe(data => {
      this.grants = data;
    });
  }

  GetTherapeuticAreas() {
    debugger;
    this.summaryService.getData("api/gmapp/gettherapeuticarealist").subscribe((result) => {
      if (result != null) {
        this.TheraputicAreaList = result;
        this.TheraputicAreaList=  [{label:"Select",value:"-1", checked: true}].concat(this.TheraputicAreaList);

      }
    });
  }

  GetOrgGrantTypes() {
    debugger;
    this.GrantTypeList=[];
    this.subGetData = this.summaryService.getData("api/common/GetOrgGrantTypesForSearch").subscribe(
      (res) => {
        this.GrantTypeList=res["Data"];
      }
    );
  }
  GetMasterData() {
    this.GetTherapeuticAreas();
    this.GetOrgGrantTypes();
  }

  setDefaultData() {
    this.columnDefs = [
      {
        "headerName": "Application ID",
        "field": "APPLICATION_CODE"
      },
      {
        "headerName": "Grant Type",
        "field": "GRANTTYPE"
      },
      {
        "headerName": "Raised By",
        "field": "CreatedStr"
      },
      {
        "headerName": "Therapeutic Area",
        "field": "TherapeuticArea"
      },
      {
        "headerName": "Status",
        "field": "StatuStr"
      },
      {
        "headerName": "Submitted On",
        // "field": "CratedDateStr"
        "field" : "SubmittedOnStr"
      },
      {
        "headerName": "Assigned To",
        "field": "AssignedStr"
      },
      {
        "headerName": "Last Updated On",
        "field": "UpdateDateStr"
      }
    ];
    this.caseDetails = [
      {
        "caseSet": {
          "caseHeading": "",
          "caseData": [
            {
              "label": "Organization Name ",
              "value": "OrgName"
            },
            {
              "label": "Tax Status",
              "value": "TaxStatus"
            },
            {
              "label": "Tax ID",
              "value": "TaxID"
            },
            {
              "label": "Application ID",
              "value": "APPLICATION_CODE"
            },
            {
              "label": "Raised By",
              "value": "CreatedStr"
            },
            {
              "label": "Email ID",
              "value": "EMail"
            },
            {
              "label": "Grant Type",
              "value": "GRANTTYPE"
            },
            {
              "label": "TherapeuticArea",
              "value": "TherapeuticArea"
            },
            {
              "label": "Status",
              "value": "StatuStr"
            },
            {
              "label": "Requested Budget",
              "value": "REQUESTED_AMOUNT"
            },
            {
              "label": "Approved Budget",
              "value": "ALLOCATION_AMOUNT"
            },
            {
              "label": "Authorized Signer",
              "value": "AUTH_SIGNER"
            }
          ]

        }
      }];
      this.advanceSearch = {
        "fields": [
          {
            "label": "Application ID",
            "field": "ApplicationID",
            "type": "text"
          },
          {
            "label": "Grant Type",
            "field": "Grant_type",
            "type": "dropdown"
          },
          {
            "label": "Therapeutic Area",
            "field": "TherapeuticArea",
            "type": "dropdown",
            "options":this.TheraputicAreaList,
          },
          {
            "label": "Status",
            "field": "STATUS",
            "type": "dropdown"
          },
          {
            "label": "Submitted From Date",
            "field": "DATEFROM",
            "type": "date"
          },
          {
            "label": "Submitted To Date",
            "field": "DATETO",
            "type": "date"
          }
        ],
        "filters": []
      }
   
    this.alloperations = [
      //{
      //  "name": "On Hold",
      //  "id": "onHold"
      //},
      //{
      //  "name": "Release",
      //  "id": "release"
      //},
      //{
      //  "name": "Route",
      //  "id": "route"
      //},
      //{
      //  "name": "Return",
      //  "id": "return"
      //},
      //{
      //  "name": "Withdraw",
      //  "id": "withdraw"
      //},
      //{
      //  "name": "Discard",
      //  "id": "discard"
      //},
      //{
      //  "name": "New Application",
      //  "id": "add"
      //}
    ];

    this.operations = this.alloperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    // this.summaryService.getGrantSearchSummary("api/common/getgrantsapp/" + event.data["ID"], null).subscribe(data => {
    //   this.grantsapp = data;
    //   let modulecode = "";
    //   if (this.grantsapp.GRANT_TYPE === 1)
    //     modulecode = "GRANTSCME";
    //   else if (this.grantsapp.GRANT_TYPE === 2)
    //     modulecode = "GRANTSSPONSORSHIP";
    //   else if (this.grantsapp.GRANT_TYPE === 3)
    //     modulecode = "GRANTSCHARITABLE";

    //   this.commonService.appId = data.ID;

    //   this.commonService.setGrantsApp(this.grantsapp);
    //   this.menudata = new ModuleMenu();
    //   this.menudata.module = modulecode;
    //   this.menudata.operation = "Edit";
    //   this.menudata.appId = this.grantsapp.ID;
    //   if (this.grantsapp.STATUS === null)
    //     this.menudata.formstate = "Draft";
    //   else
    //     this.menudata.formstate = this.commonService.getStatus(this.grantsapp.STATUS);
    //   this.commonService.setModluleMenu(this.menudata);
    //   this.header.setHeader(this.menudata);
    //   this.dataShare.setApplicationID(event.data["ID"]);
    //   this.router.navigate(['/home/grants/applications/application-ext/:' + event.data['ID'] + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", id: event.data['ID'], app_ext: true, screen_type: "applications" } })


      
    // });
    this.summaryService.getGrantSearchSummary("api/common/getgrantsapp/" +event.data["APPLICATION_ID"], null).subscribe(data => {
      debugger;this.grantsapp = data;

      let modulecode = "";
     
      if (this.grantsapp.GRANT_TYPE === 1) {
        modulecode = "GRANTSCME";
        this.grantsDataShare.setCMEID(event.data["ID"]);
      }
      else if (this.grantsapp.GRANT_TYPE === 2) {
        modulecode = "GRANTSSPONSORSHIP";
        this.grantsDataShare.setSPONSORSHIPID(event.data["ID"]);
      }
      else if (this.grantsapp.GRANT_TYPE === 3) {
        modulecode = "GRANTSCHARITABLE";
        this.grantsDataShare.setCharityID(event.data["ID"]);
      }
      this.commonService.removeLeftMenu();
      this.commonService.setGrantsApp(this.grantsapp);
      this.menudata = new ModuleMenu();
      this.menudata.module = modulecode;
      this.menudata.operation = "Edit";
      this.menudata.appId=event.data["APPLICATION_ID"];
      this.menudata.screenID = event.data['ID'];
      this.commonService.appId=event.data["APPLICATION_ID"];
      this.commonService.ScreenID=event.data["ID"];
      if (this.grantsapp.STATUS === null)
        this.menudata.formstate = "Draft";
      else
        this.menudata.formstate = this.commonService.getStatus(this.grantsapp.STATUS);
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.grantsDataShare.setGrantApplicationID(event.data["APPLICATION_ID"]);
      this.router.navigate(['/home/grants/applications/application-ext/:' + event.data["APPLICATION_ID"] + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:modulecode, id: event.data['ID'], app_ext: true, screen_type: "applications" } })

    });
  }

  assign() {
    this['self'].modalRef = this['self'].modalService.show(AssignDialogComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  add() {
    this['self'].modalRef = this['self'].modalService.show(RequestTypeModalComponent, {
      backdrop: false,
      keyboard: false,
      ignoreBackdropClick: true,
      class:'modal-vlg modal-full-height modal-right',
      animated: true,
      data: {
        id: this["self"].selectedRow['application_id']
      }
    });
    //this['self'].modalRef = this['self'].modalService.show(RequestTypeModalComponent,{class: 'modal-md modal-full-height modal-right'});


    // let url = location.href.split('/');
    // window.open(url[0]+'//'+url[2]+'/home/grants/applications/application-ext/:'+this["self"].selectedRow['id']+'/general_information');
  }

  edit() {
    this["self"].router.navigate(['/home/grants/my-applications/application-ext/:'+ this["self"].selectedRow['application_id']+'/general_information'], {skipLocationChange:true, queryParams:{module:"grants", id:this['self'].selectedRow['id'], app_ext:true, screen_type:"applications"}})
    // let url = location.href.split('/');
    // window.open(url[0] + '//' + url[2] + '/home/grants/applications/application-ext/:' + this["self"].selectedRow['id'] + '/general_information');
  }

  delete() {
    this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
  }

  route() {
    this['self'].modalService.show(RouteComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  return() {
   // this['self'].modalService.show(ReturnComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  reject() {
    // let modalRef = this['self'].modalService.show(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class: 'modal-md modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Reject',
    //     content: null
    //   }
    // });
  }

  onHold() {
    // let modalRef = this['self'].modalService.show(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class: 'modal-md modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'On-Hold',
    //     content: null
    //   }
    // });
  }

  release() {
    // let modalRef = this['self'].modalService.show(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class: 'modal-md modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Release',
    //     content: null
    //   }
    // });
  }

  withdraw() {
    this['self'].modalService.show(WithdrawComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  open(){

  }

  close(){

  }

  discard(){
    
  }

  setSearch() {
    this.SearchClear();
    this.setSearchSummary(this.grantsForm.value);
  }

  //// Advace search Functions
  SearchClear() {
    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("A")
    });
    //  this.setSummary();
  }

  AdvanceSearch() {
    this.setSearchSummary(this.grantsForm.value);
  }

  getTherapeuticAreas() {
    this.summaryService.getTherapeuticAreaList(null).subscribe((result) => {
      if (result != null) {
        this.therapeuticAreas = result;
      }
    });
  }
}
